/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 208);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__ = __webpack_require__(50);


__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].checkWihlistTagId();
  __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].bindWishListEvent();
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-form').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-form').submit(function (e) {
      e.preventDefault();
      var brand = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('brand');
      var emailField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-address');
      var email = emailField.val();
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(email).length > 0 && validateEmailField(email)) {
        saveBrandInquiryEmail(brand, email);
      } else {
        emailField.closest('.field').addClass('is-error');
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-address').keyup(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.field').removeClass('is-error');
    });
  }
});
function saveBrandInquiryEmail(brand, email) {
  var dataObject = {
    brand: brand,
    email: email
  };
  var url = window.rcProps ? window.rcProps.brandEmailSaveHref : "";
  var confirmNotificationUrl = window.rcProps ? window.rcProps.brandEmailConfirmNotificationHref : "";
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(url, dataObject, function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#brand-inquiry-email-address').val("");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: confirmNotificationUrl,
      type: 'notification',
      triggerOpen: true
    });
  });
}
function validateEmailField(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var wishlistModule = function () {
  function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
      return url;
    } else {
      return url;
    }
  }
  function addToWishList(productcode, isOneSize) {
    var size = '';
    if (isOneSize == 'true') {
      size = 'all';
    } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="size-options"]:checked').length) {
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="size-options"]:checked').val();
    }
    var b_id = 'fm_plp_' + productcode;
    var _btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + b_id);
    var email = '';
    var sectionUrl = '';
    var sessionId = '';
    var canGuestsHaveFavorites = false;
    var wishlistTagId = '';
    var department = window.rcProps.department;
    if (typeof window.rcProps.wishlist != "undefined") {
      email = window.rcProps.wishlist.email;
      sectionUrl = window.rcProps.wishlist.sectionurl;
      sessionId = window.rcProps.wishlist.sessionID;
      wishlistTagId = window.rcProps.wishlist.wishlistTagId;
      canGuestsHaveFavorites = window.rcProps.wishlist.canGuestsHaveFavorites;
      department = department || window.rcProps.pdp.department;
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".favorite-button-pdp").length > 0) {
        _btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".favorite-button-pdp");
      }
    }
    if (!email && !canGuestsHaveFavorites) {
      var wishlistTagIdPair = wishlistTagId + '=' + b_id;
      var wishlistReturnUrl = window.location.pathname + window.location.search;
      if (wishlistReturnUrl.includes(wishlistTagId)) wishlistReturnUrl = removeURLParameter(wishlistReturnUrl, wishlistTagId);
      if (wishlistReturnUrl.includes('?')) {
        wishlistReturnUrl = wishlistReturnUrl + '&' + wishlistTagIdPair;
      } else {
        wishlistReturnUrl = wishlistReturnUrl + '?' + wishlistTagIdPair;
      }
      var signInCreateAccountPage = '/fw/addToWishList.jsp?code=' + productcode + '&size=' + size + '&sectionURL=' + encodeURIComponent(sectionUrl) + '&sessionID=' + sessionId + '&redirect=true&mobile=true&returnUrl=' + encodeURIComponent(wishlistReturnUrl) + '&d=' + department;
      var signInCreateAccount = '/fw/mobile/Login.jsp?returnURL=' + encodeURIComponent(signInCreateAccountPage);
      showWishListPopup(signInCreateAccount);
    } else {
      var datastring = '&code=' + productcode + '&size=' + size + '&qty=1&sectionURL=' + encodeURIComponent(sectionUrl) + '&d=' + department;
      if (_btn.hasClass("favorite-button--active")) {
        datastring = datastring + "&cond=remove";
      } else {
        var wishlistCountUpdater = new WishlistCountUpdater();
        if (wishlistCountUpdater.showWishListMaxRestrictionPopup()) {
          return;
        }
      }
      var postUrl = "/fw/mobile/ajaxAddToWishlist.jsp?" + datastring;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: "POST",
        url: postUrl,
        success: function success(ajaxResponse) {
          try {
            var responseObject = JSON.parse(ajaxResponse.trim());
            if (responseObject.maxPopup) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('count', responseObject.data);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist_item_count").data('limit', responseObject.limit);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wish-max-popup-div').empty().append(responseObject.maxPopup);
              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                triggerOpen: true,
                open: "restrict-favorites"
              });
              return;
            }
          } catch (e) {}
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wish_nav_mpdp").css("display", "none");

          //wishlist button in plp
          var wishlistNotifyText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlistNotifyText");
          if (_btn.hasClass("favorite-button--active")) {
            wishlistNotifyText.text(wishlistNotifyText.data("wishlistadded"));
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wishlist-link').removeClass('u-hide');
            _btn.removeClass("favorite-button--active");
            if (typeof gaUpdateWishList === 'function') {
              gaUpdateWishList('remove', productcode);
            }
            if (typeof insertCordialUpdateWishList === 'function') {
              insertCordialUpdateWishList('remove', productcode);
            }
            if (typeof taboolaWishListAction === 'function') {
              taboolaWishListAction("remove", productcode);
            }
            if (typeof brazeAddToFavorites === 'function') {
              if (window.rcProps.pdp !== undefined) {
                brazeAddToFavorites('remove', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
              } else {
                brazeAddToFavorites('remove', productcode, _btn.data('name'), _btn.data('size'), _btn.data('imageurl'), _btn.data('pdpurl'), _btn.data('price'), _btn.data('currency'), _btn.data('department'), _btn.data('color'), _btn.data('brand'), _btn.data('category'), _btn.data('cat1'));
              }
            }
          } else {
            wishlistNotifyText.text(wishlistNotifyText.data("wishlistremoved"));
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wishlist-link').addClass('u-hide');
            _btn.addClass("favorite-button--active");
            if (typeof gaUpdateWishList === 'function') {
              gaUpdateWishList('add', productcode);
            }
            if (typeof iPinYouHeartItem === 'function') {
              iPinYouHeartItem(productcode);
            }
            if (typeof insertRTBHouseHeartItem === 'function') {
              insertRTBHouseHeartItem(productcode);
            }
            if (typeof insertCordialUpdateWishList === 'function') {
              insertCordialUpdateWishList('add', productcode);
            }
            if (typeof taboolaWishListAction === 'function') {
              taboolaWishListAction("add", productcode);
            }
            if (typeof brazeAddToFavorites === 'function') {
              if (window.rcProps.pdp !== undefined) {
                brazeAddToFavorites('add', productcode, window.rcProps.pdp.productName, size, window.rcProps.pdp.imageUrl, window.rcProps.pdp.pdpUrl, window.rcProps.pdp.retailPrice, window.rcProps.pdp.currency, window.rcProps.pdp.department, window.rcProps.pdp.color, window.rcProps.pdp.brandName, window.rcProps.pdp.categoryName, window.rcProps.pdp.cat1);
              } else {
                brazeAddToFavorites('add', productcode, _btn.data('name'), _btn.data('size'), _btn.data('imageurl'), _btn.data('pdpurl'), _btn.data('price'), _btn.data('currency'), _btn.data('department'), _btn.data('color'), _btn.data('brand'), _btn.data('category'), _btn.data('cat1'));
              }
            }
          }
          if (typeof window.rcProps.wishlist != "undefined") {
            updateFavoritesMessage(_btn);
          }
          //Update header wishlist count
          var wishlistCountUpdater = new WishlistCountUpdater();
          wishlistCountUpdater.updateCount();
        }
      });
    }
  }
  function updateFavoritesMessage(favBtn) {
    if (!favBtn || favBtn.length == 0) return;
    var favoriteMsg = window.rcProps.wishlist.favoriteMsg;
    var unfavoriteMsg = window.rcProps.wishlist.unfavoriteMsg;
    var favoriteNote = window.rcProps.wishlist.favoriteNote;
    var unfavoriteNote = window.rcProps.wishlist.unfavoriteNote;
    var notificationContainer = '.js-favorite-notify';
    var productDescription = favBtn.data('product-description');

    // Set messaging based on current data attribute value and rcProps values
    var favMessage = "";
    favMessage += favoriteMsg;
    favMessage += productDescription;
    var unFavMessage = "";
    unFavMessage += unfavoriteMsg;
    unFavMessage += productDescription;
    var favNotification = "";
    favNotification += productDescription;
    favNotification += favoriteNote;
    var unFavNotification = "";
    unFavNotification += productDescription;
    unFavNotification += unfavoriteNote;
    var isFav = !favBtn.hasClass('favorite-button--active');
    if (isFav) {
      favBtn.find('.u-screen-reader').html(favMessage);
      favBtn.parent().find(notificationContainer).html(unFavNotification);
    } else {
      favBtn.find('.u-screen-reader').html(unFavMessage);
      favBtn.parent().find(notificationContainer).html(favNotification);
    }
  }
  function showWishListPopup(signInCreateAccount) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "/fw/content/wishlist/login?href=" + encodeURIComponent(signInCreateAccount),
      type: "top",
      triggerOpen: true
    });
  }
  function checkWihlistTagId() {
    if (!window.rcProps || !window.rcProps.wishlist) return;
    var wishlistTagId = window.rcProps.wishlist.wishlistTagId;
    if (window.location.search.includes(wishlistTagId)) {
      var urlparts = window.location.search.split('?');
      if (urlparts.length >= 2) {
        var pars = urlparts[1].split(/[&;]/g);
        for (var i = 0; i < pars.length; i++) {
          console.log('pars[i] = ' + pars[i]);
          if (pars[i].includes(wishlistTagId)) {
            var pair = pars[i].split('=');
            if (pair.length > 0) {
              console.log('pair[1] = ' + pair[1]);
              console.log('document.getElementById(pair[1]) = ' + document.getElementById(pair[1]));
              if (document.getElementById(pair[1])) {
                console.log('scrollIntoView');
                document.getElementById(pair[1]).scrollIntoView();
              }
            }
          }
        }
      }
    }
  }
  return {
    checkWihlistTagId: checkWihlistTagId,
    bindWishListEvent: function bindWishListEvent() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').off('click').on('click', function (e) {
        var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
        var oneSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('oneSize');
        if (typeof code !== "undefined") {
          addToWishList(code, oneSize);
          iPinYouHeartItem(code);
        }
      });
    }
  };
}();
/* harmony default export */ __webpack_exports__["a"] = (wishlistModule);

/***/ })

/******/ });


// WEBPACK FOOTER //
// dist/lp.js